import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form'
import IonIcon from '@reacticons/ionicons'
import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'

// import { NewsletterForm } from './NewsletterForm/NewsletterForm'

interface NewsletterModalProps {
  isOpen: boolean
  onClose: () => void
}

const newsletterModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: '580px',
    marginRight: '-50%',
    padding: '0px',
    transform: 'translate(-50%, -50%)',
    borderWidth: '0px',
    boxShadow: '0 0 2px 2px rgba(180, 183, 197, 0.9)',
    width: '50%',
  },
  overlay: {
    zIndex: 9999,
  },
}
// Function to get modal styles based on screen size
const getNewsletterModalStyles = () => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768

  return {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      height: '580px',
      marginRight: '-50%',
      padding: '0px',
      transform: 'translate(-50%, -50%)',
      borderWidth: '0px',
      boxShadow: '0 0 2px 2px rgba(180, 183, 197, 0.9)',
      width: isMobile ? '98%' : '50%',
    },
    overlay: {
      zIndex: 9999,
    },
  }
}

// Separate component for the modal content to avoid hook issues
const NewsletterModalContent: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  const [formKey, setFormKey] = useState(0)
  const [modalStyles, setModalStyles] = useState(newsletterModalStyles)
  const { loaded } = useHubspotForm({
    portalId: '21422664',
    formId: 'bf3eb4b1-28be-4673-a308-5b95221f87b4',
    target: '#my-hubspot-form',
  })

  useEffect(() => {
    if (loaded) {
      // Refresh the form container by updating the key
      setFormKey((prev) => prev + 1)
    }
  }, [loaded])
  // Update modal styles when window resizes
  useEffect(() => {
    const handleResize = () => {
      setModalStyles(getNewsletterModalStyles())
    }
    setModalStyles(getNewsletterModalStyles())
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  return (
    <Modal id="newsletter-modal" isOpen={isOpen} onRequestClose={onClose} style={modalStyles} ariaHideApp={false}>
      <div
        className="w-full items-center justify-between"
        style={{
          background: '#fff',
          width: '96%',
          height: '766px',
          borderRadius: '15px',
          padding: '20px 0px 20px 20px',
          zIndex: '100',
          marginLeft: '10px',
          marginRight: '10px',
        }}
      >
        <div className="flex flex-row w-full">
          <span className="w-full font-primary font-bold text-textdark opacity-70 text-[18px] text-center">
            Stay informed with Legaltech Hub:
            <br />
            Subscribe to LTH Insights to receive the latest in your inbox
          </span>
          <a className="flex items-top ml-auto absolute top-[5px] right-[5px]" onClick={onClose}>
            <IonIcon name="close-outline" className="!h-[30px] !w-[30px] text-navy cursor-pointer" />
          </a>
        </div>
        <div className="flex flex-col pl-[1.25rem] pr-[1.25rem] !max-w-[1100px] w-full py-2 m-auto">
          <div className="flex flex-row w-full">
            <div className="flex flex-col w-full ">
              <div key={formKey} id="my-hubspot-form"></div>
            </div>
          </div>
        </div>
      </div>
      {/* <NewsletterForm onClose={onClose} /> */}
    </Modal>
  )
}

export const NewsletterModal: React.FC<NewsletterModalProps> = ({ isOpen, onClose }) => {
  // Only render the modal content when isOpen is true
  if (!isOpen) {
    return null
  }

  return <NewsletterModalContent isOpen={isOpen} onClose={onClose} />
}
